import { render, staticRenderFns } from "./AreaCity.vue?vue&type=template&id=4d851d90&"
import script from "./AreaCity.vue?vue&type=script&lang=js&"
export * from "./AreaCity.vue?vue&type=script&lang=js&"
import style0 from "./AreaCity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports